/**
 * Video.js Suggested Video Endcap
 * Created by Justin McCraw for New York Media LLC
 * License information: https://github.com/jmccraw/videojs-suggestedVideoEndcap/blob/master/LICENSE
 * Plugin details: https://github.com/jmccraw/videojs-suggestedVideoEndcap
 */

(function(videojs) {
  'use strict';

  var registerPlugin = videojs.registerPlugin || videojs.plugin;
  let isCreated = false;
  let canShowSuggestions = false;

  registerPlugin('suggestedVideo', function(opts) {
    var player = this;
    var _sve;

    opts = opts || {
        header: (player.localize('You may also like') + '…'),
        suggestions: [
          {
            title: '',
            url: '',
            image: '',
            alt: '',
            target: '_self'
          }
        ]
      };

    /**
     * Generate the DOM elements for the suggested video endcap content
     * @type {function}
     */
    function constructSuggestedVideoEndcapContent(sugs) {
      if (isCreated && canShowSuggestions) {
        showHideSuggested('show');
        return;
      };

      var _frag = document.createDocumentFragment();
      var _aside_wrap = document.createElement('aside');
      var _aside = document.createElement('div');
      var _div = document.createElement('div');
      var _header = document.createElement('h5');
      var _close = document.createElement('span');
      let _showStatus = canShowSuggestions ? ' is-active' : '';

      _aside_wrap.className = 'vjs-suggested-video-endcap' + _showStatus;
      _aside.className = 'vjs-suggested-video-endcap-inner';
      _div.className = 'vjs-suggested-video-endcap-container';

      _header.innerHTML = opts.header;
      _header.className = 'vjs-suggested-video-endcap-header';
      _aside.appendChild(_header);

      _close.innerHTML = '\u00D7';
      _close.className = 'vjs-suggested-video-endcap-close';
      _close.addEventListener('click', function(){
        showHideSuggested('hide');
      }, false);
      _aside_wrap.appendChild(_close);

      for (var i = 0; i < sugs.length; i++) {
        var sug = sugs[i];
        var _a = document.createElement('a');
        _a.className = 'vjs-suggested-video-endcap-link';

        if (sug.video) {
          _a.href = '#';
          (function(video_src) {
            _a.onclick = function() {
              player.src(video_src);
              player.play();
            };
          })(sug.video);
        } else if (sug.onclick) { 
          _a.href = '#';
          _a.onclick = sug.onclick;
        } else {
          _a.href = sug.url;
          _a.target = sug.target || '_self';
        }

        _a.title = sug.title;

        var _img = document.createElement('img');
        _img.className = 'vjs-suggested-video-endcap-img';
        _img.src = sug.image;
        _img.alt = sug.alt || sug.title;
        _a.appendChild(_img);
        _a.appendChild(document.createElement('br'));

        _a.innerHTML += sug.title;

        _div.appendChild(_a);
      }

      _aside.appendChild(_div);
      _aside_wrap.appendChild(_aside);
      _sve = _aside_wrap;
      _frag.appendChild(_aside_wrap);
      player.el() && player.el().appendChild(_frag);
      isCreated = true;
      checkVisibillityItems();
    }

    function checkVisibillity() {
      if (!player.el()) return;

      if (player.el().offsetHeight < 350) {
        showHideSuggested('hide');
        if (!isCreated) return;
        canShowSuggestions = false;
      } else {
        canShowSuggestions = true;
      }
    }

    function checkVisibillityItems() {
      var ind = getSuggestedCount();
      _sve.querySelectorAll('.vjs-suggested-video-endcap-link').forEach(function(el){
        el.style.display = '';
      });

      //чтобы при переходе к следующему видео отрисовывались рекомендованные
      let suggestedListContainer = _sve.querySelector('.vjs-suggested-video-endcap-container');
      suggestedListContainer.addEventListener('click', function(evt){
        let link = evt.target.closest('.vjs-suggested-video-endcap-container');
        if (!link) return;
        isCreated = false;
      }, false);

      if (player.isFullscreen()) {
        _sve.querySelectorAll('.vjs-suggested-video-endcap-link:nth-child(n+' + ++ind + ')').forEach(function(el){
          el.style.display = 'none';
        });
      }
    }

    function getSuggestedCount() {
      if (window.matchMedia("(min-width: 1580px)").matches) {
        return 10;
      }
      if (window.matchMedia("(min-width: 1280px)").matches) {
        return 8;
      }
      if (window.matchMedia("(min-width: 980px)").matches) {
        return 6;
      }
      if (window.matchMedia("(min-width: 480px)").matches) {
        return 2;
      }
      return 1;
    }

    function showHideSuggested(action) {
      var _action = (action === 'hide' && 'remove') || (action === 'show' && 'add');
      if (!_action || !isCreated) return;

      _sve.classList[_action]('is-active');
      player.el_.classList[_action]('vjs-suggested-video-endcap_showed');
    }

    function getSuggestions() {
      if (typeof opts.suggestions == 'function') {
        // function with callback
        if (opts.suggestions.toString().match(/function[^(]*\(\s*\S+\s*\)/)) {
          opts.suggestions(function(sugs) {
            if (sugs && sugs.length) {
              constructSuggestedVideoEndcapContent(sugs);
            }
          });
        } else {
          var sugs = opts.suggestions();
          if (sugs && sugs.length) {
            constructSuggestedVideoEndcapContent(sugs);
          }
        }
      }
    }

    if (opts.isPostrolls) {
      player.on('vast.lastPostrollEnd', function() {
        canShowSuggestions = true;
        getSuggestions();
      });
    } else {
      player.on('ended', function() {
        canShowSuggestions = true;
        getSuggestions();
      });
    }

    player.on('play', function() {
      canShowSuggestions = false;
      if (!isCreated) return;
      showHideSuggested('hide');
    });

    player.ready(function() {
      checkVisibillity();
      if (typeof opts.suggestions != 'function') constructSuggestedVideoEndcapContent(opts.suggestions);
      window.addEventListener("resize", resize);
    });

    function resize(){
      checkVisibillity();
      _sve && checkVisibillityItems();
    }
  });
}(window.videojs));
